export default __webpack_public_path__ + "a49e3d66f040b5750cafbc153bf3d64e.svg";